import * as React from "react";
import { UitkCheckbox } from "uitk-react-switch";
import { UitkExpandoLink, UitkExpandoLinkTypeSize } from "uitk-react-expando";
import { UitkLayoutGrid, UitkLayoutGridItem, UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { ViewMedium, Viewport, ViewSmall } from "bernie-view";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";
import { WizardHotelFilterType } from "./WizardHotelFilterType";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { withStores } from "stores";
import { PropertyFiltersStore } from "src/stores/PropertyFiltersStore";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { usePropertySearchQuery } from "src/stores/PropertyFiltersStore/usePropertySearchQuery";
import { Checkbox } from "components/shared/PropertyFIlterComponents/components/Checkbox";
import { observer } from "mobx-react";
import { CheckboxModuleNameTypes } from "src/components/shared/PropertyFIlterComponents/components/Checkbox";
import { UitkSpacing } from "uitk-react-spacing";

const WizardHotelFilterList = [
  WizardHotelFilterType.businessFriendly,
  WizardHotelFilterType.freeCancellation,
  WizardHotelFilterType.familyFriendly,
  WizardHotelFilterType.breakfastIncluded,
];
const WizardHotelFilterListMobile = [
  WizardHotelFilterType.businessFriendly,
  WizardHotelFilterType.familyFriendly,
  WizardHotelFilterType.freeCancellation,
  WizardHotelFilterType.breakfastIncluded,
];

interface WizardHotelPWAFilterProps {
  checkboxFilterChecks: object;
  changeFormProperties?: (event: React.ChangeEvent<HTMLFormElement>) => void;
  advancedOptionsFilterVisible?: boolean;
  propertyFilters: PropertyFiltersStore;
  context?: ExtendedContextStore;
  popularFiltersColSpan?: UitkLayoutConditionalGridSpan;
  isDynamicFilters?: boolean;
}

export const WizardHotelPWAFilter = withStores("propertyFilters")((props: WizardHotelPWAFilterProps) => {
  const { checkboxFilterChecks, changeFormProperties, advancedOptionsFilterVisible, isDynamicFilters } = props;
  const { formatText } = useLocalization();
  const title = formatText(locKeys.filterAdvancedOptionsLink);

  if (isDynamicFilters) {
    return <WizardDynamicFilters {...props} />;
  }

  return (
    <UitkLayoutFlex space="three">
      <UitkExpandoLink
        type={UitkExpandoLinkTypeSize.TYPE_300}
        expandoTitle={title}
        isVisible={advancedOptionsFilterVisible}
      >
        <Viewport>
          <ViewSmall>
            <>
              {WizardHotelFilterListMobile.map(({ id, key, filterTypeKey, name, value }) => (
                <UitkCheckbox
                  id={id}
                  name={name}
                  label={formatText(filterTypeKey)}
                  checked={checkboxFilterChecks[key]}
                  onChange={changeFormProperties}
                  value={value}
                  key={key}
                />
              ))}
            </>
          </ViewSmall>
          <ViewMedium>
            <UitkLayoutGrid columns={2}>
              {WizardHotelFilterList.map(({ id, key, filterTypeKey, name, value }) => (
                <UitkLayoutGridItem key={key}>
                  <UitkSpacing padding={{ inlineend: "six" }}>
                    <div>
                      <UitkCheckbox
                        id={id}
                        name={name}
                        label={formatText(filterTypeKey)}
                        checked={checkboxFilterChecks[key]}
                        onChange={changeFormProperties}
                        value={value}
                      />
                    </div>
                  </UitkSpacing>
                </UitkLayoutGridItem>
              ))}
            </UitkLayoutGrid>
          </ViewMedium>
        </Viewport>
      </UitkExpandoLink>
    </UitkLayoutFlex>
  );
});

interface WizardDynamicFiltersProps
  extends Pick<WizardHotelPWAFilterProps, "propertyFilters" | "popularFiltersColSpan"> {
  context: ExtendedContextStore;
}

const WizardDynamicFilters = withStores(
  "context",
  "propertyFilters"
)(
  observer((props: WizardDynamicFiltersProps) => {
    const { propertyFilters, context, popularFiltersColSpan } = props;
    const { data, error, loading } = usePropertySearchQuery(context);

    const response = data?.propertySearch.sortAndFilter.options?.sortAndFilter;

    if (error || loading || !response) {
      return <div data-testid="no-property-filters" />;
    }

    if (propertyFilters.isEmpty()) {
      propertyFilters.setFilters(response);
    }

    const freeCancellationFilter = propertyFilters.getFreeCancellationFilter();

    return (
      <>
        {freeCancellationFilter && (
          <UitkLayoutGridItem colSpan={popularFiltersColSpan}>
            <div>
              <UitkLayoutFlexItem>
                <Checkbox
                  option={freeCancellationFilter}
                  filterName="paymentType"
                  moduleName={CheckboxModuleNameTypes.WIZARD_HOTEL_V2_HTG}
                />
              </UitkLayoutFlexItem>
            </div>
          </UitkLayoutGridItem>
        )}
        {propertyFilters
          .getPopularFilters()
          .filter((_, index) => index < 3)
          .map((filter, index) => {
            return (
              <UitkLayoutGridItem key={`${filter.optionValue}-${index}`} colSpan={popularFiltersColSpan}>
                <div>
                  <UitkLayoutFlexItem>
                    <Checkbox
                      option={filter}
                      filterName="popularFilter"
                      moduleName={CheckboxModuleNameTypes.WIZARD_HOTEL_V2_HTG}
                    />
                  </UitkLayoutFlexItem>
                </div>
              </UitkLayoutGridItem>
            );
          })}
      </>
    );
  })
);
